import {
    cilBell,
    cilCalendarCheck,
    cilGraph,
    cilLan,
    cilSpeedometer,
    cilStar,
    cilUser,
    cilViewQuilt,
} from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CNavGroup, CNavItem } from '@coreui/react';

import AddForms from './views/add-forms/AddForms.jsx';
import AnamnesisBuilder from './views/anamnesis-builder/AnamnesisBuilder.jsx';
import AppointmentsMapping from './views/appointments-mapping/AppointmentsMapping.jsx';
import Appointments from './views/appointments/Appointments.jsx';
import Dashboard from './views/dashboard/Dashboard.jsx';
import PractitionersMapping from './views/practitioners-mapping/PractitionersMapping.jsx';
import ProfessionalView from './views/professionals/ProfessionalView.jsx';
import Professionals from './views/professionals/Professionals.jsx';
import Quicksight from './views/quicksight/Quicksight.jsx';
import TodaysAppointments from './views/todaysappointments/TodaysAppointments.jsx';
import Users from './views/users/Users.jsx';

export const pageKeys = {
    ETERNO_DASHBOARD: 'eterno-dashboard',
    ETERNO_USERS: 'eterno-users',
    ETERNO_PROFESSIONALS: 'eterno-professionals',
    ETERNO_TODAY_APPOINTMENTS: 'eterno-today-appointments',
    ETERNO_FORMS_PORTAL: 'eterno-forms-portal',
    ETERNO_APPOINTMENTS: 'eterno-appointments',
    ETERNO_DC_APPOINTMENT_TYPES: 'eterno-dc-appointment-types',
    ETERNO_ANAMNESIS_BUILDER: 'eterno-anamnesis-builder',
    ETERNO_PRACTITIONERS_MAPPING: 'eterno-practitioners-mapping',
    ETERNO_APPOINTMENTS_MAPPING: 'eterno-appointments-mapping',
    ETERNO_QUICKSIGHT: 'eterno-quicksight',
    ETERNO_ANALYTICS: 'eterno-analytics',
};

export const routes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        key: pageKeys.ETERNO_DASHBOARD,
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        key: pageKeys.ETERNO_USERS,
    },
    {
        path: '/professionals',
        name: 'Professionals',
        component: Professionals,
        key: pageKeys.ETERNO_PROFESSIONALS,
    },
    {
        path: '/today-appointments',
        name: 'Heutige Termine',
        component: TodaysAppointments,
        key: pageKeys.ETERNO_TODAY_APPOINTMENTS,
    },
    {
        path: '/forms-portal',
        name: 'Forms Portal',
        component: AddForms,
        key: pageKeys.ETERNO_FORMS_PORTAL,
    },
    {
        path: '/appointments',
        name: 'Appointments',
        component: Appointments,
        key: pageKeys.ETERNO_APPOINTMENTS,
    },
    {
        path: '/anamnesis-builder',
        name: 'Anamnesis Builder',
        component: AnamnesisBuilder,
        key: pageKeys.ETERNO_ANAMNESIS_BUILDER,
    },
    {
        path: '/professional-view',
        name: 'Professional View',
        component: ProfessionalView,
        key: pageKeys.ETERNO_DC_APPOINTMENT_TYPES,
    },
    {
        path: '/quicksight',
        name: 'Quicksight',
        component: Quicksight,
        key: pageKeys.ETERNO_QUICKSIGHT,
    },
    {
        path: '/practitioners-mapping',
        name: 'Practitioners Mapping View',
        component: PractitionersMapping,
        key: pageKeys.ETERNO_PRACTITIONERS_MAPPING,
    },
    {
        path: '/appointments-mapping',
        name: 'Appointments Mapping View',
        component: AppointmentsMapping,
        key: pageKeys.ETERNO_APPOINTMENTS_MAPPING,
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
export const _nav = [
    {
        component: CNavItem,
        name: 'Heutige Termine',
        to: '/today-appointments',
        icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_TODAY_APPOINTMENTS,
    },
    {
        component: CNavItem,
        name: 'Users',
        to: '/users',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_USERS,
    },
    {
        component: CNavItem,
        name: 'Professionals',
        to: '/professionals',
        icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_PROFESSIONALS,
    },
    {
        component: CNavItem,
        name: 'Appointment',
        to: '/appointments',
        icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_APPOINTMENTS,
    },
    {
        component: CNavItem,
        name: 'Forms Portal',
        to: '/forms-portal',
        icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_FORMS_PORTAL,
    },
    {
        component: CNavGroup,
        name: 'Analytics',
        to: '/analytics',
        icon: <CIcon icon={cilLan} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_ANALYTICS,
        items: [
            {
                component: CNavItem,
                name: 'Dashboard',
                to: '/dashboard',
                icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
            },
            {
                component: CNavItem,
                name: 'Quicksight',
                to: '/quicksight',
                icon: <CIcon icon={cilViewQuilt} customClassName="nav-icon" />,
            },
        ],
    },
    {
        component: CNavGroup,
        name: 'Mappings',
        to: '/mappings',
        icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
        key: pageKeys.ETERNO_PRACTITIONERS_MAPPING,
        items: [
            {
                component: CNavItem,
                name: 'Practitioners Mapping',
                to: '/practitioners-mapping',
            },
            {
                component: CNavItem,
                name: 'Appointments Mapping',
                to: '/appointments-mapping',
            },
        ],
    },
];
